import {MutableRefObject} from "react";

export const isIFrame = (input: HTMLElement | null): input is HTMLIFrameElement =>
  input !== null && input.tagName === 'IFRAME';


export const getElementByIdFromIframe = (elementId: string) => {
  let element = null
  const iframe = document.getElementById('handiscover-iframe')
  if (isIFrame(iframe) && iframe?.contentWindow) {
    element = iframe.contentWindow.document.getElementById(elementId)
  }
  return element
}

export const getIframeDocument = () => {
  const iframe = document.getElementById('handiscover-iframe')
  if (isIFrame(iframe) && iframe.contentWindow) {
    const { document } = iframe.contentWindow
    return document
  }
  return null
}

export const scrollToUnitByCurrentImage = (
  refs: MutableRefObject<HTMLDivElement[] | null[]>,
  currentImageData: {index: number, accessibility_unit: string, name: string},
  containerId: string
) => {
  const foundIndexForScroll = refs.current.findIndex((i: any) => (
    i?.id === currentImageData.accessibility_unit
  ))
  if (foundIndexForScroll !== -1) {
    const elementForScroll = refs.current[foundIndexForScroll]
    if (elementForScroll) {
      const container = getElementByIdFromIframe(containerId)
      if (container && container.children[1]) {
        const containerRect = container?.children[1].getBoundingClientRect()
        // scrollIntoView behaves strangely if the widget is in an iframe
        if (window.self !== window.top) {
          if (container?.children[1] && containerRect) {
            container?.children[1].scrollTo({
              top: elementForScroll?.offsetTop - containerRect.top,
              behavior: 'smooth'
            })
          }
        } else {
          elementForScroll.scrollIntoView({behavior: 'smooth'})
        }
      }
    }
  }
}
